// Replace stale search/date filters so this shortcut shows the complete PC queue.
export const ownPendingEmailFilters = (initialFilters, productCurator) => {
  if (!productCurator) return null

  const filters = Object.keys(initialFilters).reduce((result, key) => ({ ...result, [key]: '' }), {})
  return { ...filters, product_curator: productCurator, state: '', email_status: 'not_sent,failed' }
}
